/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SubscriptionType {
    UNKNOWN = 'unknown',
    TRIAL = 'trial',
    PREMIUM = 'premium',
    PROMOTIONAL = 'promotional',
}
